export { login, logout, getUserAccount, getUserProfile, loginB2C, authProvider } from 'services/AuthService';
export const api = require('./APIService');